import { motion } from "framer-motion";
import roadImage from "../../../assets/AppDevelopment/road.png";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const cardData = [
  {
    title: "Wider Market Reach",
    desc: "Android powers over 70% of the global mobile OS market, giving your business access to a massive and diverse audience.",
    icon: "🌍",
  },
  {
    title: "Customizable & Scalable",
    desc: "From startups to enterprises, Android allows for complete customization, integrations, and scalability as your business grows.",
    icon: "⚙️",
  },
  {
    title: "Fast Deployment",
    desc: "With flexible development tools and easy Play Store deployment, we help you get to market quicker than ever.",
    icon: "🚀",
  },
  {
    title: "Secure Architecture",
    desc: "Built with modern security protocols, our Android apps offer secure user data management and top-notch performance.",
    icon: "🔐",
  },
];
 const steps = [
    { step: "Requirement Gathering", percent: 20 },
    { step: "UI/UX Wireframes", percent: 40 },
    { step: "Development Sprint", percent: 60 },
    { step: "Testing & Debugging", percent: 80 },
    { step: "Launch & Support", percent: 100 },
  ];


export default function AndroidAppDevelopmentPage() {
  return (
    <div className="bg-black text-white overflow-x-hidden">

      <Helmet>
  <title>Custom Android App Development | Nadezhda Venture</title>
  <meta
    name="description"
    content="Build scalable, high-performance Android apps with Kotlin and Java. Custom UI/UX, secure backend, Play Store deployment, and full support."
  />
  <meta
    name="keywords"
    content="Android App Development, Kotlin, Java, Custom Android Apps, Best Android Developers in Noida, Mobile App Company, Nadezhda Venture"
  />
  <meta name="author" content="Nadezhda Venture" />

  {/* Open Graph / Facebook */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Android App Development | Nadezhda Venture" />
  <meta
    property="og:description"
    content="Get secure, scalable Android apps developed by experts. End-to-end support, modern UI/UX, and faster deployment."
  />
  <meta property="og:image" content="https://www.biovustechnologies.com/blog/wp-content/uploads/2021/08/software-development.jpg" />
  <meta property="og:url" content="https://www.nadezhdaventure.com/android-app-development" />


</Helmet>


     {/* Hero Section */}
<section className="h-[400px] bg-gradient-to-br from-gray-900 via-black to-gray-950 relative overflow-hidden flex items-center justify-center">
  {/* Background Image */}
  <img
    src="https://www.biovustechnologies.com/blog/wp-content/uploads/2021/08/software-development.jpg"
    className="absolute inset-0 w-full h-full object-cover opacity-50 z-0" // Adjusted opacity for a more subtle background
    alt="Android Background"
  />

  {/* Overlay with blur for glass-like effect */}
  <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-0" /> {/* Added backdrop-blur for a subtle glass effect */}

  {/* Content */}
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
    className="relative z-10 max-w-4xl px-6 py-32 md:py-48 text-center md:text-left" // Centered for better responsiveness
  >
    <div>
      <h1 className="text-4xl md:text-5xl font-extrabold text-orange-400 mb-4">
        Custom Android App Development
      </h1>
      <p className="text-lg md:text-xl text-gray-300">
        Powerful, scalable apps tailored for your audience and business goals. And we do it with Kotlin and Java, ensuring top-notch performance and user experience.
      </p>
        <div className="mt-8">
           <Link to="/contact">
  <button className="bg-orange-700 hover:bg-orange-500 px-6 py-3 rounded-lg font-semibold transition text-white">
    Get Started 
  </button>
</Link>
        </div>
    </div>
  </motion.div>
</section>

     {/* Why Android Section */}
<section className="relative py-20 px-6 bg-white">
  <div className="relative z-10 max-w-6xl mx-auto text-center">
    <h2 className="text-3xl md:text-4xl font-bold text-orange-500 mb-6">
      Why Go Android?
    </h2>
    <p className="text-lg text-gray-900 max-w-3xl mx-auto mb-12">
      As one of the top app development companies, we deploy the world’s most powerful platforms for launching apps. Our Android solutions are crafted to stay ahead of the curve, ensuring your digital success.
    </p>

    {/* Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {cardData.map((card, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.2 }}
          className="bg-blue-950 backdrop-blur-md p-6 rounded-2xl shadow-lg text-left border border-orange-600"
        >
          <div className="text-4xl mb-4">{card.icon}</div>
          <h3 className="text-xl font-semibold text-orange-500 mb-2">
            {card.title}
          </h3>
          <p className="text-gray-400 leading-relaxed">{card.desc}</p>
        </motion.div>
      ))}
    </div>
  </div>
</section>


      {/* Our Android Services Section */}
      <section className="py-20 px-6 bg-gray-300 relative overflow-hidden">
       
        
       

        <motion.h2
          className="text-4xl font-bold text-center text-orange-500 mb-12 relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          Our Android Services
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto relative z-10">
          {[
            "Native App Development",
            "Custom UI/UX for Android",
            "Play Store Deployment",
            "API Integration",
            "Maintenance & Support",
            "Migration to Android",
          ].map((service, i) => (
            <motion.div
              key={i}
              className="
                bg-blue-950
                p-6
                rounded-2xl
                border-2
                border-gray-700
                transition
                duration-300
               hover:border-orange-500
               hover:shadow-[0_0_20px_rgba(255,165,0,0.5)]
                cursor-pointer
              "
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <h4 className="text-xl font-semibold text-white mb-2">
                {service}
              </h4>
            </motion.div>
          ))}
        </div>
      </section>


     {/* Technologies We Use Section */}
     <section className="py-20 px-6 bg-white to-orange-900 relative overflow-hidden">
        {/* Subtle background pattern */}
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/dark-circles.png')] opacity-10 pointer-events-none"></div>

        <h2 className="text-3xl font-bold text-center text-orange-500 mb-12 relative z-10">Technologies We Use</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto relative z-10">
          {[
            { name: "Kotlin", logo: "https://img.icons8.com/color/48/kotlin.png" },
            { name: "Java", logo: "https://img.icons8.com/color/48/java-coffee-cup-logo.png" },
            { name: "Firebase", logo: "https://img.icons8.com/color/48/firebase.png" },
            { name: "Android Studio", logo: "https://img.icons8.com/color/48/android-studio--v3.png" },
            { name: "Jetpack", logo: "https://logo.svgcdn.com/d/jetpackcompose-original.png" },
            { name: "SQLite", logo: "https://img.icons8.com/ios-filled/48/sql.png" },
            { name: "Retrofit", logo: "https://img.icons8.com/ios-filled/48/api.png" },
            { name: "XML", logo: "https://img.icons8.com/color/48/xml-file.png" },
            { name: "Flutter", logo: "https://img.icons8.com/color/48/flutter.png" },
            { name: "React Native", logo: "https://img.icons8.com/color/48/react-native.png" },
            { name: "Node.js", logo: "https://img.icons8.com/color/48/nodejs.png" },
            { name: "MongoDB", logo: "https://img.icons8.com/color/48/mongodb.png" },
          ].map((tech, i) => (
            <motion.div
              key={i}
              className=" bg-blue-200 backdrop-blur-sm
                p-6
                rounded-2xl
                border-2
                border-gray-700
                transition
                duration-300
                hover:border-orange-600
                hover:shadow-[0_0_20px_rgba(255,165,0,0.5)]
                flex flex-col items-center justify-center
                cursor-pointer"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <img src={tech.logo} alt={`${tech.name} logo`} className="mx-auto mb-2 w-12 h-12" />
              <p className="text-black text-center font-semibold">{tech.name}</p> {/* Changed text to white */}
            </motion.div>
          ))}
        </div>
      </section>

     {/* Development Process Section */}
     <section className="py-20 px-6 bg-transparent-black relative overflow-hidden">
        {/* Subtle background dots pattern */}
        <div className="absolute inset-0 bg-[url('https://media.licdn.com/dms/image/v2/C511BAQHxjUNbm0bvNg/company-background_1536_768/company-background_1536_768/0/1583882155231?e=2147483647&v=beta&t=b8cqy3HNOmwzHblH2-Q8FNZhTrlyZPKHgwu45jEO-js')] opacity-10 pointer-events-none"></div>

      <h2 className="text-3xl font-bold text-center text-orange-500 mb-12 relative z-10">Development Process</h2>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center relative z-10">

        {/* Left side: Steps with progress bars */}
        <div className="space-y-12">
          {steps.map((item, i) => (
            <motion.div
              key={i}
              className="flex items-center gap-6 bg-gray-800/60 backdrop-blur-sm p-4 rounded-lg border border-gray-700"
              initial={{ opacity: 0, x: i % 2 === 0 ? -100 : 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="w-10 h-10 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold flex-shrink-0">
                {i + 1}
              </div>
              <div className="flex-1">
                <h4 className="text-xl font-semibold text-white mb-2">{item.step}</h4>
                <div className="relative bg-gray-700 rounded-full h-2 overflow-hidden max-w-[300px]">
                  <motion.div
                    className="h-2 bg-orange-500 rounded-full"
                    initial={{ width: 0 }}
                    whileInView={{ width: `${item.percent}%` }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    viewport={{ once: true }}
                  />
                </div>
                <p className="text-gray-300 text-sm mt-1">{item.percent}% Completed</p>
              </div>
            </motion.div>
          ))}
        </div>

       <motion.div
            className="w-full max-w-2xl mx-auto"
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
            <img
                src="https://corizo.in/wp-content/uploads/2024/11/Android-Development.png"
                alt="Roadmap"
                className="w-full max-h-[600px] rounded-lg shadow-lg object-contain bg-gray-800/50 backdrop-blur-sm p-4" // Added subtle background to image
            />
        </motion.div>


      </div>
    </section>

      {/* Impact Section */}
      <section className="flex flex-col md:flex-row items-center gap-10 px-6 py-20 bg-white relative overflow-hidden">
       

        <motion.img
          src="https://png.pngtree.com/thumb_back/fh260/background/20230717/pngtree-d-rendered-user-interface-optimization-for-mobile-app-development-and-mobile-image_3891939.jpg"
          alt="Impact"
          className="w-full md:w-1/2 rounded-xl shadow-lg relative z-10" // Ensured image is above new overlays
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        />
        <motion.div
          className="flex-1 text-white relative z-10" // Ensured text is above new overlays
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <h2 className="text-3xl font-bold text-orange-500 mb-4">Real Impact, Real Results</h2>
         <p className="text-black text-lg leading-relaxed"> 
            From innovative startups to established enterprises, our meticulously crafted Android applications have consistently transformed business operations and significantly elevated user experiences. We don't just build apps; we architect digital solutions that drive growth, enhance efficiency, and create lasting connections with your audience. With every project, we are committed to bringing your unique vision to life, ensuring measurable success in the dynamic mobile landscape.
          </p>
        </motion.div>
      </section>

      {/* Call to Action */}
      {/* <section className="relative py-20 px-6 bg-black"> 
        <img
          src="https://www.itl.cat/pngfile/big/327-3275928_software-development-mobile-software.jpg"
          className="absolute inset-0 w-full h-full object-cover opacity-15 z-0" // Adjusted opacity further
          alt="CTA Background"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent backdrop-blur-[2px]"></div> 
        <div className="relative z-10 max-w-3xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold text-orange-500 mb-4">Ready to Build Your Android App?</h2>
          <p className="text-lg text-gray-200 mb-6">
            Let’s discuss your ideas and turn them into reality. We’re just one click away.
          </p>
          <button className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg font-semibold transition">
            Contact Us
          </button>
        </div>
      </section> */}

    </div>
  );
}